<template>
  <v-card class="pb-2 mb-2" width="100%" elevation=10>
    <v-card-title style="cursor: pointer;" class="pt-0 mt-2 pb-1" @click="show = !show">{{ shader.title }}
     <v-spacer></v-spacer>
      <v-switch @click="toggleEnable" class="ma-0 pa-0" v-model="shader.properties.isEnabled" hide-details></v-switch>
      <v-btn icon @click="removeShader">
        <v-icon>{{'mdi-trash-can'}}</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider class="pb-3"></v-divider>
    <div>
      <v-expand-transition>
      <div v-show="show">
        <v-list-item v-for="(value, name) in shader.uniforms" :key="name">
          <Row :title="name">
          <NumberController v-if="typeof(value.value) == 'number' || typeof(value.value) == 'string'" v-model="value.value">
          </NumberController>
          <div v-if="isVector2(value)">
              <NumberController width="50" v-model="value.value.x">
              </NumberController>
              <NumberController width="50" v-model="value.value.y">
              </NumberController>
          </div>
          <v-switch v-if="isBoolean(value)" class="ma-0 pt-0" v-model="value.value">
          </v-switch>
          <!-- <v-text-field v-if="typeof(value.value) == 'number' || typeof(value.value) == 'string'" step=0.1 hide-details :append-icon="isAlreadyDefaultUniform(name) ? '' : 'mdi-restore'" @click:append="(e) => restoreUniformDefault(name, e)" @input="updateChange" v-model="value.value" :label="name" :value="value.value" type="number"></v-text-field>-->

          <ColorPicker v-if="isColor(value)" :append-icon="isAlreadyDefaultUniform(name) ? '' : 'mdi-restore'" @click:append="(e) => restoreUniformDefault(name, e)" @input="updateColorChange(value, $event)" :label="name" :value="'#' + value.value.getHexString().toUpperCase()"></ColorPicker>
          </Row>

        </v-list-item>
      </div>
      </v-expand-transition>
    </div>
  </v-card>
</template>

<script>
import { Color, Vector2 } from 'three';
import ColorPicker from './ColorPicker.vue'
import Row from './Row.vue'
import NumberController from './NumberController.vue'
  export default {
    name: 'ShaderCard',
    components: {
        ColorPicker,
        Row,
        NumberController,
    },
    methods: {
        isBoolean(value) {
            return value.value instanceof Boolean;
        },
        isColor(value) {
            return value.value instanceof Color;
        },
        isVector2(value) {
            return value.value instanceof Vector2;
        },
        toggleEnable: function(e) {
            e.stopPropagation();
            this.updateChange();
        },
        updateColorChange: function(value, e) {
            //console.log(e);
            value.value.set(e);
        },
        updateChange: function() {
            this.$store.commit('updateShadersParameters');
        },
        removeShader: function(e) {
            e.stopPropagation();
            this.$store.commit('removePostProcessingShader', this.shader);
        },
        isAlreadyDefaultUniform: function(uniformName) {
            if (!this.shader || !this.shader.uniforms || !this.shader.defaultUniforms) {
                return true;
            }

            if (this.shader.uniforms[uniformName].value == this.shader.defaultUniforms[uniformName].value) {
                return true;
            }
            return false;
        },
        restoreUniformDefault: function(uniformName) {
            this.shader.uniforms[uniformName].value = this.shader.defaultUniforms[uniformName].value;
            //this.updateChange();

            return true;
        },
    },
    data: function () {
        return {show: true,
               };
    },
    mounted: function() {
    },
    props: ['shader'],
  }
</script>
